module.exports = __webpack_public_path__ + "img/undraw1.ebbf0b33.svg";